import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Row, Col, Avatar, Select } from 'antd'
import 'antd-country-phone-input/dist/index.css'
import 'antd/dist/antd.css'
import 'antd-country-phone-input/dist/index.css'
import moment from 'moment'
import EventManager from './InputComps/EventManager'
import OrganizationInput from 'components/global/inputs/OrganizationInput/OrganizationInput'
import ButtonSpinner from 'components/global/ButtonSpinner'
import {
  OrgOrganizerParams,
  OrgOrganizerType,
  OrganizationVenues,
  SpecialSchedule,
} from 'types/organization'
import { FormValues, Step1BodyTypes } from 'types/Classes/Classes'
import {
  useGetEventCategories,
  useCreateEventStep1Mutation,
} from 'api/EventCreation/EventCreation'
import { useGetOrgOrganizers } from 'api/Organizations'
import { CategoryType, Address, OrganizationResp, Photo } from 'types/globalTypes'
import Loader from 'helper/Loader'
import { infoMessage } from 'api/global'
import DateandTimeInputs from './InputComps/DateandTimeInputs'
import VenuType from './InputComps/VenuType'
import { classesEventStore } from 'state/classes/classesStore'
import CategoryInput from './InputComps/CategoryInput'
import {
  combineDateAndTimeToUtcString,
  convertMinutesToLocalTime,
  convertTimeToUtcMinutes,
  forceRefetch,
} from 'helper/utility'
import { useQueryClient } from '@tanstack/react-query'
import { useGetOrganizationDetails } from 'api/Organizations'
import { Link, useHistory } from 'react-router-dom'
import { EventCategoryListing } from 'types/listing/listings'
import UploadDocument from 'components/global/UploadDocument'
import { useCreateClassStep1Mutation } from 'api/Classes/Classes'

interface GeneralDetailsTypes {
  handleNext: (childData: any) => void
}

const GeneralDetail: React.FC<GeneralDetailsTypes> = ({ handleNext }) => {
  const history = useHistory()
  const [form] = Form.useForm()
  const queryClient = useQueryClient()
  const [isUpdated, setIsUpdated] = useState<boolean>(false)
  const [categoryVal, setCategoryVal] = useState<EventCategoryListing>()
  const { classesData, setClassesData, setRequiredDetails, coverPhotoIds, setCoverPhotoIds, coverPhotos, setCoverPhotos } = classesEventStore(
    store => ({
      classesData: store.classesData,
      setClassesData: store.setClassesData,
      setRequiredDetails: store.setRequiredDetails,
      coverPhotoIds: store.coverPhotoIds,
      setCoverPhotoIds: store.setCoverPhotoIds,
      coverPhotos: store.coverPhotos,
      setCoverPhotos: store.setCoverPhotos,
    }),
  )
  const [selectedOrganization, setSelectedOrganization] =
    useState<OrganizationResp>(classesData ? classesData.organization : undefined)
  const [selectedOrganizer, setSelectedOrganizer] = useState<string[]>([])
  const [specialScheduleData, setSpecialScheduleData] = useState(
    classesData ? classesData.timings?.specialSchedules : [],
  )
  const [venueDataItem, setVenueDataItem] = useState<OrganizationVenues | null>(
    classesData ? classesData.venue : undefined,
  )
  const [mapData, setMapModalData] = useState<Address | null>(null)
  const [isEventOnline, setEventOnline] = useState<boolean>(false)
  const [isDefaultOrganizer, setIsDefaultOrganizer] = useState<boolean>(true)
  const [defaultOrganizer, setDefaultOrganizer] = useState(null)
  const [eventTime, setEventTime] = useState({
    startTime: undefined,
    endTime: undefined,
  })
  const [defaultTime, setDefaultTime] = useState({
    startTime: moment('09:00', 'HH:mm'),
    endTime: moment('15:00', 'HH:mm'),
  })

  const [params, setParams] = useState<OrgOrganizerParams>({
    status: 'approved',
  })
  const {
    data: organizationDetials,
    isLoading: orgLoading,
    isFetching: orgFetching,
    refetch: organizationRefetch,
  } = useGetOrganizationDetails(classesData?.organizationId)

  const formSchema = {
    venueType: classesData ? classesData.venueType : 'physical',
  }

  useEffect(() => { }, [selectedOrganization])

  useEffect(() => {
    if (selectedOrganizer?.length > 0) {
      setIsDefaultOrganizer(false)
    }
  }, [selectedOrganizer])

  useEffect(() => {
    form.setFieldsValue({ venue: venueDataItem?.name })
  }, [venueDataItem])

  useEffect(() => {
    form.setFieldsValue({ organizationId: selectedOrganization?.name })
    setSelectedOrganization(selectedOrganization)
  }, [selectedOrganization])

  useEffect(() => {
    if (!orgLoading && !orgFetching) {
      if (organizationDetials) {
        setDefaultOrganizer(organizationDetials.owner)
      }
    }
  }, [orgLoading || orgFetching])

  useEffect(() => {
    if (classesData?.timings) {
      setDefaultTime({
        startTime: moment(
          convertMinutesToLocalTime(classesData?.timings.startTime, 'HH:mm'),
          'HH:mm',
        ),
        endTime: moment(
          convertMinutesToLocalTime(classesData?.timings.endTime, 'HH:mm'),
          'HH:mm',
        ),
      })
    }
  }, [classesData?.timings])

  const { mutate: createStep1, isLoading: createStep1Loading } =
    useCreateClassStep1Mutation()

  const onFinish = (values: FormValues) => {
    if (!values) {
      infoMessage('Form data is missing')
      return
    }
    if (!selectedOrganization) {
      infoMessage('Organization is required')
      return
    }
    if (!values.title) {
      infoMessage('Class name is required')
      return
    }
    if (!categoryVal) {
      infoMessage('Category is required')
      return
    }
    if (selectedOrganizer.length === 0) {
      return infoMessage('Class manager is required')
    }
    if (!values.venueType) {
      infoMessage('Venue type is required')
      return
    }
    if (selectedDates.length === 0) {
      infoMessage('Class dates are required')
      return
    }
    if (selectedOrganization && values.venueType === 'physical') {
      if (!mapData) {
        infoMessage('Location is required')
        return
      }
      if (!venueDataItem) {
        infoMessage('Venue is required')
        return
      }
    }

    const payload: Step1BodyTypes = {
      title: values.title,
      categoryId: categoryVal._id,
      organizationId: selectedOrganization.id,
      organizerId: isDefaultOrganizer ? defaultOrganizer._id : selectedOrganizer[0],
      venueType: values.venueType,
      location: values.venueType === 'physical' ? mapData : undefined,
      locationId: values.locationId,
      venueUrl: values.venuUrl,
      venueId: values.venueType === 'physical' ? (venueDataItem?._id || '') : undefined,
      datesOfEvent: selectedDates.map((item: string) =>
        combineDateAndTimeToUtcString(
          item,
          moment(eventTime.startTime).format('hh:mm A'),
        ),
      ),
      timings: {
        startTime: convertTimeToUtcMinutes(eventTime.startTime),
        endTime: convertTimeToUtcMinutes(eventTime.endTime),
        specialSchedules: specialScheduleData.map((data: SpecialSchedule) => ({
          startTime: data.startTime,
          endTime: data.endTime,
          day: data.day,
        })),
      },
      minGuestsRequired: values.minGuestsRequired ? Number(values.minGuestsRequired) : undefined,
      maxGuestsAllowed: values.maxGuestsAllowed ? Number(values.maxGuestsAllowed) : undefined,
      guestsRequiredToIncreaseMax: values.guestsRequiredToIncreaseMax ? Number(values.guestsRequiredToIncreaseMax) : undefined,
      dailyGuestLimit: values.dailyGuestLimit ? Number(values.dailyGuestLimit) : undefined,
      coverPhotosIds: coverPhotoIds,
      deleteObject: {
        minGuestsRequired: values.minGuestsRequired === '' ? 1 : undefined,
        maxGuestsAllowed: values.maxGuestsAllowed === '' ? 1 : undefined,
        guestsRequiredToIncreaseMax: values.guestsRequiredToIncreaseMax === '' ? 1 : undefined,
        dailyGuestLimit: values.dailyGuestLimit === '' ? 1 : undefined,
      },
    }
    createStep1(
    {
      body: payload,
    },
    {
      onSuccess: result => {
        setIsUpdated(true)
        setClassesData(result)
        setRequiredDetails(result.requiredDetails)
        handleNext({ ...values, location: mapData })
      },
    },
  )
  }

  const [selectedDates, setSelectedDates] = useState<string[]>([])
  const {
    data: eventCategories,
    isLoading: eventCategoryLoading,
    refetch: eventCategoryRefetch,
  } = useGetEventCategories()

  const {
    data: orgOrganizers,
    isLoading: orgOrganizersLoading,
    refetch: orgOrganizersRefetch,
  } = useGetOrgOrganizers(params, selectedOrganization?.id)

  useEffect(() => {
    if (!selectedOrganization) {
      forceRefetch('org-organizers', queryClient)
    }
  }, [selectedOrganization])
  useEffect(() => {
    eventCategoryRefetch()
  }, [])
  useEffect(() => {
    if (selectedOrganization) {
      orgOrganizersRefetch()
    }
  }, [selectedOrganization])

  useEffect(() => {
    if (orgOrganizers && !classesData) {
      let temp = orgOrganizers?.find(
        (item: OrgOrganizerType) => item.accessLevel === 'owner',
      )
      setDefaultOrganizer(temp?.organizer)
      setSelectedOrganizer([temp?.organizerId])
    }
  }, [orgOrganizers])

  useEffect(() => {
    if (!isUpdated && classesData) {
      organizationRefetch()
      form.setFieldsValue({
        name: classesData.name,
        venueType: classesData.venueType || 'physical',
        dailyGuestLimit: classesData?.dailyGuestLimit,
        minGuestsRequired: classesData?.minGuestsRequired,
        maxGuestsAllowed: classesData?.maxGuestsAllowed,
        guestsRequiredToIncreaseMax: classesData?.guestsRequiredToIncreaseMax,
      })

      setCategoryVal(classesData.category)
      setSelectedOrganization(classesData.organization)
      setSelectedOrganizer(
        classesData?.organizers?.map(
          (organizer: OrgOrganizerType) => organizer._id,
        ),
      )
      setVenueDataItem(classesData.venue)
      setMapModalData(classesData.location)
      setEventOnline(classesData.venueType === 'virtual')
      setEventTime({
        startTime: moment(
          convertMinutesToLocalTime(classesData?.timings.startTime, 'HH:mm'),
          'HH:mm',
        ),
        endTime: moment(
          convertMinutesToLocalTime(classesData?.timings.endTime, 'HH:mm'),
          'HH:mm',
        ),
      })
      setSpecialScheduleData(classesData.timings?.specialSchedules)
      setSelectedDates(
        classesData?.datesOfEvent.map((date: string) =>
          moment(date).format('YYYY-MM-DD'),
        ),
      )
      setCoverPhotoIds(classesData.coverPhotosIds || [])
      setCoverPhotos(classesData.coverPhotos || [])
    } else {
      form.resetFields()
      setCategoryVal(undefined)
      setSelectedOrganization(undefined)
      setSelectedOrganizer(
        classesData?.organizers?.map(
          (organizer: OrgOrganizerType) => organizer._id,
        ),
      )
      setVenueDataItem(undefined)
      setMapModalData(undefined)
      setEventOnline(false)
      setEventTime({
        startTime: undefined,
        endTime: undefined,
      })
      setSelectedDates([])
      setCoverPhotoIds([])
      setCoverPhotos([])
    }
  }, [classesData])

  return (
    <>
      {eventCategoryLoading ? (
        <Loader />
      ) : (
        <div>
          <Form
            form={form}
            layout="horizontal"
            initialValues={formSchema}
            onFinish={onFinish}
          >
            <div
              className="create-event-main-content-box"
              style={{ margin: '0 auto' }}
            >
              <h2>Step 1. General Details</h2>
              {/* <Row gutter={10}>
                <Col>
                  <label className="input-label required-input">
                    Title
                  </label>
                </Col>
                <Col>
                  <Form.Item className="form-control" name="title">
                    <Input
                      placeholder="Title"
                      className="form-control-field"
                    />
                  </Form.Item>
                </Col>
              </Row> */}

              <OrganizationInput
                selectedOrganization={selectedOrganization}
                setSelectedOrganization={setSelectedOrganization}
              />
              {orgOrganizers?.length > 0 && (
                <EventManager
                  selectedOrganizer={selectedOrganizer}
                  setSelectedOrganizer={setSelectedOrganizer}
                  orgOrganizers={orgOrganizers}
                  defaultOrganizer={defaultOrganizer}
                />
              )}

              <Row gutter={10}>
                <Col>
                  <label className="input-label required-input">
                    Class name
                  </label>
                </Col>
                <Col>
                  <Form.Item className="form-control" name="title">
                    <Input
                      placeholder="Class name"
                      className="form-control-field"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <CategoryInput
                category={categoryVal}
                setCategory={setCategoryVal}
              />

              <VenuType
                isEventOnline={isEventOnline}
                setEventOnline={setEventOnline}
                selectedOrganization={selectedOrganization}
                mapData={mapData}
                setMapModalData={setMapModalData}
                venueDataItem={venueDataItem}
                setVenueDataItem={setVenueDataItem}
              />

              <DateandTimeInputs
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                specialScheduleData={specialScheduleData}
                setSpecialScheduleData={setSpecialScheduleData}
                eventTime={eventTime}
                setEventTime={setEventTime}
                defaultTime={defaultTime}
                setDefaultTime={setDefaultTime}
              />

              <Row gutter={10}>
                <Col>
                  <label className="input-label">Description</label>
                  <Form.Item className="form-control" name="description">
                    <Input.TextArea
                      className="answer-field"
                      placeholder="Few words about the class"
                      autoSize={{ minRows: 5, maxRows: 8 }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={18}>
                  <label className="input-label">Add Cover</label>
                  <UploadDocument
                    documentIds={coverPhotoIds}
                    setDocumentIds={setCoverPhotoIds}
                    multiple={true}
                    docType="image/*"
                    files={coverPhotos}
                    uploadMultipleAtOnce={true}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 15 }}>
                {/* <Col>
                  <h4 className="b1 mb-15">Guests limitation</h4>
                </Col>
                <Col className="d-flex align-items-center">
                  <div style={{ width: '100%' }}>
                    <span>Daily guests Limit</span>
                  </div>
                  <Form.Item name="dailyGuestLimit" style={{ width: '20%' }}>
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end br-5"
                    />
                  </Form.Item>
                </Col> */}
                <Col className="d-flex align-items-center">
                  <div style={{ width: '100%' }}>
                    <span>Minimum guests required</span>
                  </div>
                  <Form.Item name="minGuestsRequired" style={{ width: '20%' }}>
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end br-5"
                    />
                  </Form.Item>
                </Col>
                <Col className="d-flex align-items-center">
                  <div style={{ width: '100%' }}>
                    <span>Maximum guests required</span>
                  </div>
                  <Form.Item name="maxGuestsAllowed" style={{ width: '20%' }}>
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end br-5"
                    />
                  </Form.Item>
                </Col>
                <Col className="d-flex align-items-center">
                  <div style={{ width: '100%' }}>
                    <span>Guests required to open waitlist</span>
                  </div>
                  <Form.Item
                    name="guestsRequiredToIncreaseMax"
                    style={{ width: '20%' }}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="text-end br-5"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify="space-between" className="mb-26 mt-40px">
                <Button
                  className="cancel-button"
                  onClick={() => history.goBack()}
                >
                  Back to listing
                </Button>

                <Button
                  className="stepper-button"
                  disabled={createStep1Loading}
                  htmlType="submit"
                >
                  {createStep1Loading ? (
                    <ButtonSpinner color="#000" size={20} />
                  ) : (
                    'Next'
                  )}
                </Button>
              </Row>
            </div>
          </Form>
        </div>
      )}
    </>
  )
}

export default GeneralDetail
